'use client';

import { cn } from '@/lib/utils';
import { useTranslations } from 'next-intl';

interface AddToCartControlsProps {
    onAddToCart: () => void;
    isLoading: boolean;
    isDisabled: boolean;
    className?: string;
}

/**
 * A component combining quantity controls and add to cart button
 */
export default function AddToCartControls({
    onAddToCart,
    isLoading,
    isDisabled,
    className = '',
}: AddToCartControlsProps) {
    const t = useTranslations('Cart');

    return (
        <div className={cn('mb-4 flex items-center gap-4', className)}>
            <button
                type="button"
                onClick={onAddToCart}
                className="button flex min-w-[120px] items-center justify-center bg-haug-lila-100 text-white hover:bg-haug-lila-200"
                disabled={isLoading || isDisabled}
            >
                {isLoading ? (
                    <svg
                        className="-ml-1 mr-2 h-4 w-4 animate-spin text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                    >
                        <title>{t('loading')}</title>
                        <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                        ></circle>
                        <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        ></path>
                    </svg>
                ) : null}
                {t('addToCart')}
            </button>
        </div>
    );
}
